export function download(
  filename: string,
  contents: string,
  mime: string = "text/plain"
): void {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    `data:${mime};charset=utf-8,${encodeURIComponent(contents)}`
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}
